import React from 'react'
import {LockIcon} from '../../../components/icons'
import {CheckoutBonusCardStatus} from '../../../types/store/common'
import {BaseButton, ButtonProps, Stack, Text} from '../../../vanilla'
import {useOrderStore} from '../../../store/hooks/useStore'

export interface CheckoutButtonProps extends ButtonProps {
  submitOrderProcess: () => Promise<void | null>
  isEditModeEnabled: boolean
  isTopUp: boolean
  billingAddressFormValid: boolean
  isPaymentRefunding: boolean
  braintreeFormIsValid: boolean
  bonusCardStatus: CheckoutBonusCardStatus
  hostedFieldsErrors: boolean
  }

export const CheckoutButton = (props: CheckoutButtonProps) => {
  const {
    submitOrderProcess,
    isEditModeEnabled,
    isTopUp,
    billingAddressFormValid,
    isPaymentRefunding,
    braintreeFormIsValid,
    bonusCardStatus,
    hostedFieldsErrors,
    ...rest
  } = props

  const {isPaymentRequired} = useOrderStore()
  return (
    <Stack {...rest}>
      <BaseButton
      variant="primary"
      width="full"
      onClick={() => submitOrderProcess()}
      data-test-selector="pay-securely"
      disabled={
        isPaymentRequired
          ? !billingAddressFormValid ||
            (!isPaymentRefunding
              ? (!braintreeFormIsValid && !bonusCardStatus?.hidePayment) || hostedFieldsErrors
              : false)
          : false
      }
    >
      {isEditModeEnabled ? (
        <Text variant="unstyled">Update Your Order Now</Text>
      ) : (
        <>
          <Text variant="unstyled">{isTopUp ? 'Top up' : 'Pay'} Securely</Text>
          &nbsp;
          <LockIcon />
        </>
      )}
      </BaseButton>
    </Stack>
  )
}
